import { graphql } from 'react-apollo'
import { ApplicationError } from '../../helpers/errors'
import { getRetailCategories } from '../../helpers/categories-helper'
import query from './query.graphql'

const mapDataToProps = ({ data: { loading, error, centre } }) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  }

  return {
    loading,
    centreCategories:
      centre && getRetailCategories(centre._backrefs.stores__via__centre),
  }
}

const mapPropsToOptions = ({ centre }) => ({
  variables: {
    centreID: centre.sys.id,
  },
})

const withStoreRetailCategories = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withStoreRetailCategories
